import { connect } from 'react-redux';
import { ToxnotComponentProperties } from "../core/BaseApplicationComponents/ToxnotComponent";
import { ToxnotSignInRequiredComponent } from "../core/BaseApplicationComponents/ToxnotSignInRequiredComponent";
import { ApplicationState } from "../../store";
import { TeamRole } from '../../store/Models/UserContext';
import Layout from "../Layout";
import {
    ToxnotMainApplicationViewComponent, ToxnotMainApplicationViewComponentReadOnly,
    ViewOptions
} from "../core/BaseApplicationComponents/ToxnotMainApplicationViewComponent";
import {SurveyResponseInventoryGroup} from "../../store/Models/Surveys/SurveyDataModel";
import {SimpleInventory} from "../../store/Models/Inventories/SimpleInventory";
import {ObtainmentReportsResult} from "../../store/Models/Api/ObtainmentReports/ObtainmentReportsResult";
import {ToxnotReactTable} from "../core/ToxnotReactTable";

enum UiState {
    Loading,
    Failed,
    Loaded
}

interface LocalState {
    uiState: UiState;
    pageIndex: number;
    obtainmentReportsData: ObtainmentReportsResult;
}

class ObtainmentReports extends ToxnotMainApplicationViewComponentReadOnly<ToxnotComponentProperties, UiState, LocalState> {
    private readonly rowsPerPage: number;

    constructor(props: ToxnotComponentProperties) {
        super(props);

        this.rowsPerPage = 50;

        this.state = {
            uiState: UiState.Loading,
            pageIndex: 0,
            obtainmentReportsData: {
                totalNumReports: 0,
                pageOfReports: []
            }
        };
    }

    protected getDisallowedRoles(): TeamRole[] {
        return [];
    }

    // ===============================================================================

    protected getPostInitialLoadUiState() {
        return UiState.Loaded;
    }

    // ===============================================================================

    protected async fetchViewDataAndRefreshState() {
        const apiResult = await this._serviceClient.getObtainmentReports(this.state.pageIndex, this.rowsPerPage);

        if (!this.apiDataFetchWasSuccessful(apiResult) || (apiResult.data == null)) {
            this.enterFailedState();

            return;
        }

        this.setState({
            uiState: UiState.Loaded,
            obtainmentReportsData: apiResult.data
        });
    }

    // ===============================================================================

    protected getLocalizedViewTitle(): string | null {
        return this.localizeString("Obtainment Reports");
    }

    protected renderViewContent(): JSX.Element | null {
        const userContext = this.getUserContext();

        if (userContext == null) {
            throw new Error("user context not set");
        }

        if (!userContext.userCapabilities.obtainmentReportsEnabled) {
            return (
                <p>{this.localizeString("You don't have access to view Obtainment Reports")}</p>
            );
        }

        return (
            <>
                <ToxnotReactTable rowsPerPage={this.rowsPerPage} headerRow={[{ value: this.localizeString("Date") }, { value: "" }]} allRowModels={this.state.obtainmentReportsData.pageOfReports} getRowForTable={reportData => ({
                    cols: [(new Date(reportData.dateAdded).toLocaleString('en-US', {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: true // Adjust to false for 24-hour format
                    })), <a href={`/Api/GeneralFile?fileId=${encodeURIComponent(reportData.reportFileId)}`}>{this.localizeString("Download")}</a>] })} localizer={this.props.appServices} currentPage={this.state.pageIndex} totalNoResult={this.state.obtainmentReportsData.totalNumReports} onPageChange={this.table_onPageChange} />
            </>
        );
    }

    private table_onPageChange = (pageNumber: number) => {
        this._serviceClient.getObtainmentReports(pageNumber, this.rowsPerPage)
            .then(apiResult => {
                if (!this.apiDataFetchWasSuccessful(apiResult) || (apiResult.data == null)) {
                    this.enterFailedState();

                    return;
                }

                this.setState({
                    uiState: UiState.Loaded,
                    obtainmentReportsData: apiResult.data,
                    pageIndex: pageNumber
                });
            });
    }
}

export default connect(
    (state: ApplicationState) => ({ appServices: state.appServices })
)(ObtainmentReports as any);
